import { uniq, isEqual } from 'lodash';
import moment from 'moment';
import types from './types';

import createMetadataAPIReducer from '../../utils/api-metadata-reducer';

const initialState = {
  byMembershipAndSkillId: {},
  lastError: null,
  error: null,
  lastFetch: null,
  loading: false
};

// Example structure:
//
// {
//  byMembershipAndSkillId: {
//    123: { // membershipId
//      432: [ // skillId
//         {
//            owner_id: 123,
//            skill_id: 432,
//            start_time: ...,
//            end_time: ...
//         },
//         {
//            owner_id: 123,
//            skill_id: 432,
//            start_time: ...,
//            end_time: ...
//         }
//      ]
//    }
// }

const defaultReducer = createMetadataAPIReducer({ baseType: 'CERTIFICATIONS' });
const emptyArray = [];

export default (state = initialState, action) => {
  switch (action.type) {
    case types.CLEAR_CERTIFICATIONS: {
      console.log('Clearing certifications for membershipId', action.payload.membershipId);
      const { membershipId } = action.payload;
      const newById = { ...state.byMembershipAndSkillId };
      delete newById[membershipId];
      return {
        ...state,
        byMembershipAndSkillId: newById
      };
    }
    case types.SUCCESS: {
      const certifications = action.payload.data;

      let newById = { ...state.byMembershipAndSkillId };

      const ownerIds = uniq(certifications.map(c => c.owner_id));

      if (action.replace) for (const id of ownerIds) delete newById[id];

      for (const c of certifications) {
        newById[c.owner_id] = newById[c.owner_id] || {};
        newById[c.owner_id][c.skill_id] = newById[c.owner_id][c.skill_id] || emptyArray;
        newById[c.owner_id][c.skill_id] = [...newById[c.owner_id][c.skill_id], c];
      }

      for (const id of ownerIds) {
        // avoid unnecessary updates if values are exactly the same
        if (isEqual(newById[id], state.byMembershipAndSkillId[id])) newById[id] = state.byMembershipAndSkillId[id];
      }

      return {
        ...state,
        byMembershipAndSkillId: newById,
        lastFetch: moment().format(),
        loading: false
      };
    }
    default: {
      return defaultReducer(state, action);
    }
  }
};
